<template>
  <div class="layout-options-setting-dialog">
    <div class="content-group-default">
      <el-collapse v-model="activeNames" style="width: 100%">
        <el-collapse-item title="状态" name="1" v-if="isAccordionLayoutCol">
          <template slot="title">
            状态
            <i class="tips-btn icon-portal-info2" @click.stop="explainDialogClick(2)"></i>
          </template>
          <cx-slider label="状态" :value.sync="status" :options="statusOptions"></cx-slider>
        </el-collapse-item>
        <el-collapse-item
          @mousedown.native="collapseMouseDown($event, '2')"
          title="尺寸"
          name="2"
          v-if="isAccordionLayoutCol"
        >
          <template slot="title">
            尺寸
            <i class="tips-btn icon-portal-info2"></i>
          </template>
          <div class="verticallyCenter" v-if="status === '0'">
            <div class="verticallyCenter mr12 flex1">
              <span class="fs14 mr8 color000">宽</span>
              <single-input
                value="-"
                style="width: 100%"
                :value.sync="defaultWidth"
                inputSuffixs="%"
                :min="1"
                :max="Number(defaultWidthMax)"
              />
            </div>
            <!-- <div class="verticallyCenter flex1">
              <span class="fs14 mr8 color000">高</span>
              <single-input
                value="-"
                style="width: 100%"
                :value.sync="showHeightVal"
                inputSuffixs="px"
                :min="1"
                :max="accordionMaxHeight"
              />
            </div> -->
            <div class="verticallyCenter flex1">
              <span class="fs14 mr8 color000">高</span>
              <el-input
                :type="heightType === 'px' ? 'number' : ''"
                style="width: 100%"
                :disabled="disabledHeight"
                v-model="showHeightVal"
                class="input-size"
                :min="1"
                :max="accordionMaxHeight"
              >
                <template slot="suffix">
                  <el-dropdown trigger="click" @command="heightTypeHandleCommand">
                    <span class="el-dropdown-link lineHeight32" v-if="heightType === 'px'">
                      {{ heightType }}
                    </span>
                    <span class="el-dropdown-link lineHeight32 icon-portal-fill-height" v-else></span>
                    <el-dropdown-menu slot="dropdown" class="dropdown-size">
                      <el-dropdown-item v-for="(sizeType, index) in heightFullTypes" :key="index" :command="sizeType.value">
                        <span
                          class="selected-icon"
                          :class="heightType === sizeType.value ? 'icon-portal-check-small' : ''"
                        ></span>
                        {{ sizeType.label }}
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </template>
              </el-input>
            </div>
          </div>
          <div class="verticallyCenter" v-if="status === '1'">
            <div class="verticallyCenter mr12 flex1">
              <span class="fs14 mr8 color000">宽</span>
              <single-input
                value="-"
                style="width: 100%"
                v-if="status === '1'"
                :value.sync="activeWidth"
                :min="1"
                :max="Number(activeWidthMax)"
                inputSuffixs="%"
              />
            </div>
            <!-- <div class="verticallyCenter flex1">
              <span class="fs14 mr8 color000">高</span>
              <single-input
                value="-"
                style="width: 100%"
                :value.sync="activeHeight"
                inputSuffixs="px"
                :min="1"
                :max="accordionMaxHeight"
              />
            </div> -->
            <div class="verticallyCenter flex1">
              <span class="fs14 mr8 color000">高</span>
              <el-input
                :type="activeHeightType === 'px' ? 'number' : ''"
                style="width: 100%"
                :disabled="disabledActiveHeight"
                v-model="activeHeight"
                class="input-size"
                :min="1"
                :max="accordionMaxHeight"
              >
                <template slot="suffix">
                  <el-dropdown trigger="click" @command="activeHeightTypeHandleCommand">
                    <span class="el-dropdown-link lineHeight32" v-if="activeHeightType === 'px'">
                      {{ activeHeightType }}
                    </span>
                    <span class="el-dropdown-link lineHeight32 icon-portal-fill-height" v-else></span>
                    <el-dropdown-menu slot="dropdown" class="dropdown-size">
                      <el-dropdown-item v-for="(sizeType, index) in heightFullTypes" :key="index" :command="sizeType.value">
                        <span
                          class="selected-icon"
                          :class="activeHeightType === sizeType.value ? 'icon-portal-check-small' : ''"
                        ></span>
                        {{ sizeType.label }}
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </template>
              </el-input>
            </div>
          </div>
        </el-collapse-item>
        <controlWidthAndSizeAndZindex v-else-if="!(topAdaptContentHeight && layoutLevel === 4 )" :options="options" :ids="ids" />
        <el-collapse-item
          @mousedown.native="collapseMouseDown($event, '2')"
          title="尺寸"
          name="2"
          v-else
        >
          <div class="verticallyCenter">
            <div class="verticallyCenter mr12 flex1">
              <span class="fs14 mr8 color000">宽</span>
              <single-input
                value="-"
                style="width: 100%"
                v-if="positionType && positionType !== 'relative'"
                :value.sync="showWidthVal"
                inputSuffixs="%"
              />
              <el-input v-else type="number" value="-" disabled style="width: 100%" v-model="showWidthVal">
                <template slot="suffix">
                  <span class="suffix_text">%</span>
                </template>
              </el-input>
            </div>
            <div class="verticallyCenter flex1">
              <span class="fs14 mr8 color000">高</span>
              <single-input style="width: 100%"  :value.sync="showHeightVal" inputSuffixs="px" />
            </div>
          </div>
        </el-collapse-item>
<!--        <el-collapse-item-->
<!--          @mousedown.native="collapseMouseDown($event, '2')"-->
<!--          title="尺寸"-->
<!--          name="2"-->
<!--          v-if="!showRowColLayout"-->
<!--        >-->

<!--          <div class="verticallyCenter">-->
<!--            <div class="verticallyCenter mr12 flex1">-->
<!--              <span class="fs14 mr8 color000">宽</span>-->
<!--              <single-input-->
<!--                value="-"-->
<!--                style="width: 100%"-->
<!--                v-if="positionType && positionType !== 'relative'"-->
<!--                :value.sync="showWidthVal"-->
<!--                inputSuffixs="%"-->
<!--              />-->
<!--              <el-input v-else type="number" value="-" disabled style="width: 100%" v-model="showWidthVal">-->
<!--                <template slot="suffix">-->
<!--                  <span class="suffix_text">%</span>-->
<!--                </template>-->
<!--              </el-input>-->
<!--            </div>-->
<!--            <div class="verticallyCenter flex1">-->
<!--              <span class="fs14 mr8 color000">高</span>-->
<!--              <single-input style="width: 100%" :disabled="true" value="100" inputSuffixs="%" />-->
<!--            </div>-->
<!--          </div>-->
<!--        </el-collapse-item>-->
        <el-collapse-item title="排列" name="3" v-if="isAccordionLayoutRow">
          <div class="verticallyCenter">
            <span class="fs14 mr16">列数</span>
            <div class="row-set verticallyCenter el-input">
              <single-input
                class="mr8"
                style="width: 104px; height: 32px; flex: 1"
                :value.sync="colLen"
                :noInputSuffixs="true"
                :noInputHandle="true"
              />
              <div class="btn-wrapper">
                <span
                  :class="colLen === 2 ? 'disabled num-btn icon-portal-minus' : 'num-btn icon-portal-minus'"
                  @click="changeColLen(0)"
                ></span>
                <span
                  :class="colLen === 10 ? 'disabled num-btn icon-portal-plus' : 'num-btn icon-portal-plus'"
                  @click="changeColLen(1)"
                ></span>
              </div>
            </div>
          </div>
          <slider-and-input
            class="mt12"
            :value.sync="accordionMargin"
            title="间距"
            :sliderMax="100"
            suffix="px"
          />
          <cx-slider class="mt12" label="对齐" :value.sync="alignmentType" :options="alignmentTypeOptions" :showToolTip="true" />
        </el-collapse-item>
        <el-collapse-item title="排列" name="3" v-if="(isCanAddRow || isCanAddCol) && layoutLevel < 7 && !isAccordionLayoutRow && !isAccordionLayoutCol">
          <!-- 支持添加多个图文 -->
          <!-- 产品要求不要这两个设置项 新老布局分割开-->
          <!--          <div class="content-item mb12" style="height: 20px; line-height: 20px">-->
          <!--            <el-checkbox v-model="showMultipleLayout">支持多个自由布局</el-checkbox>-->
          <!--          </div>-->
          <!--          <div-->
          <!--            class="content-item mb12"-->
          <!--            style="height: 20px; line-height: 20px"-->
          <!--            v-if="!showRowColLayout && colLen === 1 && isLastLevel && layoutLevel === 2 && parentLayout.layout.rows.length === 1"-->
          <!--          >-->
          <!--            <el-checkbox v-model="waterFlow">流式布局</el-checkbox>-->
          <!--          </div>-->
          <!--          竖向布局标签，最后一层允许先添加行，再添加列-->
          <div class="verticallyCenter mb16" v-if="isCanAddRow">
            <span class="fs14 mr16">行数 </span>
            <div class="row-set">
              <div class="verticallyCenter el-input">
                <single-input
                  class="mr8"
                  style="width: 104px; height: 32px; flex: 1"
                  :value.sync="rowLen"
                  :noInputSuffixs="true"
                  :min="1"
                  :max="10"
                  :noInputHandle="true"
                />
                <div class="btn-wrapper">
                  <span
                    :class="rowLen === 1 ? 'disabled num-btn icon-portal-minus' : 'num-btn icon-portal-minus'"
                    @click="changeRowLen(0)"
                  ></span>
                  <span
                    :class="rowLen === 10 ? 'disabled num-btn icon-portal-plus' : 'num-btn icon-portal-plus'"
                    @click="changeRowLen(1)"
                  ></span>
                </div>
              </div>
            </div>
          </div>
          <!--          横向布局标签，最后一层允许先添加列，再添加行-->
          <div class="verticallyCenter" v-if="isCanAddCol">
            <span class="fs14 mr16">列数</span>
            <div class="row-set flex1">
              <div class="num-btn add-col-wrap" @click="changeColLen(1)">
                <span class="icon icon-portal-plus"></span>
                <span>添加同级列</span>
              </div>
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item
          title="排列"
          name="3"
          v-show="isAccordionLayoutCol && showRowColLayout">
          <div v-if="showRowColLayout">
            <rowColLayoutSetting :options="layoutOptions" :ids="ids" @update="handleSet" />
          </div>
        </el-collapse-item>
        <el-collapse-item
          @mousedown.native="collapseMouseDown($event, '2')"
          title="尺寸"
          name="2"
          v-show="showRowColLayout && !isAccordionLayoutCol"
        >
          <template slot="title">
            尺寸
            <i class="tips-btn icon-portal-info2"></i>
            <span class="stop-blank" @click.stop></span>
            <div class="add-size" @click.stop v-if="heightType === '自动' && (!showMaxHeight || !showMinHeight)">
              <el-dropdown @command="addHandleCommand" trigger="click">
                <span class="el-dropdown-link icon-portal-plus"></span>
                <el-dropdown-menu slot="dropdown" class="custom-menu">
                  <el-dropdown-item
                    v-for="(size, index) in sizeLists"
                    :key="'size' + index"
                    :command="size.value"
                    v-show="size.show"
                  >
                    <span class="icon" :class="size.icon"></span>{{ size.label }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </template>
          <div class="verticallyCenter">
            <div class="verticallyCenter mr12 flex1">
              <span class="fs14 mr8 color000">宽</span>
              <el-input
                type="number"
                value="-"
                v-if="positionType && positionType !== 'relative'"
                style="width: 100%"
                v-inputHandle="{ this1, type: 'showWidthVal' }"
                v-model="showWidthVal"
              >
                <template slot="suffix">
                  <span class="suffix_text">%</span>
                </template>
              </el-input>
              <el-input v-else type="number" value="-" disabled style="width: 100%" v-model="showWidthVal">
                <template slot="suffix">
                  <span class="suffix_text">%</span>
                </template>
              </el-input>
            </div>
            <div class="verticallyCenter flex1">
              <span class="fs14 mr8 color000">高</span>
              <el-input
                value="-"
                style="width: 100%"
                :disabled="disabledHeight"
                v-model="showHeightVal"
                class="input-size"
              >
                <template slot="suffix">
                  <el-dropdown trigger="click" @command="heightTypeHandleCommand">
                    <span class="el-dropdown-link lineHeight32" v-if="heightType === 'px'">
                      {{ heightType }}
                    </span>
                    <span class="el-dropdown-link lineHeight32" :class="heightIcon" v-else></span>
                    <el-dropdown-menu slot="dropdown" class="dropdown-size">
                      <el-dropdown-item v-for="(sizeType, index) in heightTypes" :key="index" :command="sizeType.value">
                        <span
                          class="selected-icon"
                          :class="heightType === sizeType.value ? 'icon-portal-check-small' : ''"
                        ></span>
                        {{ sizeType.label }}
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </template>
              </el-input>
            </div>
          </div>
          <div class="flexEnd" v-if="heightType === '自动'">
            <div style="width: 50%; padding-left: 6px">
              <div class="verticallyCenter mt8" v-if="showMaxHeight">
                <span class="fs14 mr8 icon-portal-max-height"></span>
                <el-input
                  type="number"
                  class="input-size"
                  placeholder="最大高"
                  v-model="maxHeight"
                  @focus="getFocus($event)"
                >
                  <template slot="suffix">
                    <el-dropdown trigger="click" @command="delHandleCommand('showMaxHeight')">
                      <span class="el-dropdown-link lineHeight32">px</span>
                      <el-dropdown-menu slot="dropdown" class="custom-menu">
                        <el-dropdown-item> <span class="icon icon-portal-close-small"></span>移除最大高度 </el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </template>
                </el-input>
              </div>
              <div class="verticallyCenter mt8" v-if="showMinHeight">
                <span class="fs14 mr8 icon-portal-min-height"></span>
                <el-input
                  type="number"
                  class="input-size"
                  placeholder="最小高"
                  v-model="minHeight"
                  @focus="getFocus($event)"
                >
                  <template slot="suffix">
                    <el-dropdown trigger="click" @command="delHandleCommand('showMinHeight')">
                      <span class="el-dropdown-link lineHeight32">px</span>
                      <el-dropdown-menu slot="dropdown" class="custom-menu">
                        <el-dropdown-item> <span class="icon icon-portal-close-small"></span>移除最小高度 </el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </template>
                </el-input>
              </div>
            </div>
          </div>
        </el-collapse-item>
        <!-- start 手风琴布局下只有默认状态下展示 -->
        <template v-if="!isAccordionLayoutCol || (isAccordionLayoutCol && status === '0')">
        
        <el-collapse-item title="背景" name="4">
          <cx-background infoTips="支持上传图片" :background.sync="background" imgType="10" />
        </el-collapse-item>
        <el-collapse-item title="边框" name="5">
          <div>
            <div class="content-item verticallyCenter mb8">
              <el-checkbox v-model="showBorder">显示边框</el-checkbox>
            </div>
            <cx-border
              :borderWidth.sync="borderWidth"
              :borderStyle.sync="borderStyle"
              :borderColor.sync="borderColor"
              :borderIsThemeColor.sync="borderIsThemeColor"
            />
          </div>
          <div class="content-item mt12">
            <border-radius
              :borderTypeFlag.sync="borderTypeFlag"
              :borderRadius.sync="borderRadius"
              :borderTopLeftRadius.sync="borderTopLeftRadius"
              :borderTopRightRadius.sync="borderTopRightRadius"
              :borderBottomRightRadius.sync="borderBottomRightRadius"
              :borderBottomLeftRadius.sync="borderBottomLeftRadius"
            />
          </div>
        </el-collapse-item>

        <!-- <el-collapse-item @mousedown.native="collapseMouseDown($event, '4')" title="外观" name="4">
          <div
            class="setting-item"
            v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '4')"
          >
            <div class="content-item mb16">
              <slider-and-input :value.sync="opacity" title="透明度" :sliderMax="100" suffix="%" />
            </div>
            <div class="content-item verticallyCenter mb16" v-show="showRowColLayout">
              <span class="mr16">溢出</span>
              <text-setting-overflow :overFlowType.sync="overFlowType" style="flex: 1"></text-setting-overflow>
            </div>
            <div class="content-item mb16">
              <border-radius
                :borderTypeFlag.sync="borderTypeFlag"
                :borderRadius.sync="borderRadius"
                :borderTopLeftRadius.sync="borderTopLeftRadius"
                :borderTopRightRadius.sync="borderTopRightRadius"
                :borderBottomRightRadius.sync="borderBottomRightRadius"
                :borderBottomLeftRadius.sync="borderBottomLeftRadius"
              />
            </div>
            <div class="content-item mb24 clearFloat">
              <div class="checkbox_colorPicker_container mb16">
                <span class="fs14">边框</span>
              </div>
              <div class="select-input-container verticallyTop">
                <cx-border
                  :borderWidth.sync="borderWidth"
                  :borderStyle.sync="borderStyle"
                  :borderColor.sync="borderColor"
                  :borderIsThemeColor.sync="borderIsThemeColor"
                />
              </div>
            </div>
            <div class="content-item">
              <cx-background :background.sync="background" imgType="10" class="mt16" />
            </div>
            <div class="content-item mt16">
              <div class="checkbox_colorPicker_container">
                <span>阴影</span>
                <span class="icon-portal-plus theme-color right-icon" @click="addBoxshadow"></span>
              </div>
              <box-shadow
                :boxShadowH.sync="boxShadowH"
                :boxShadowV.sync="boxShadowV"
                :boxShadowBlur.sync="boxShadowBlur"
                :boxShadowSpread.sync="boxShadowSpread"
                :boxShadowColor.sync="boxShadowColor"
              ></box-shadow>
            </div>
          </div>
        </el-collapse-item> -->
        <el-collapse-item v-if="isLastLevel || isAccordionLayoutRow" @mousedown.native="collapseMouseDown($event, '6')" title="边距" name="6">
          <cx-padding
            v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '6')"
            :paddingTypeFlag.sync="paddingTypeFlag"
            :padding.sync="padding"
            :paddingTop.sync="paddingTop"
            :paddingRight.sync="paddingRight"
            :paddingBottom.sync="paddingBottom"
            :paddingLeft.sync="paddingLeft"
            :sliderMax="500"
          />
          <!--添加外边距-->
          <!-- 屏蔽根布局外边距 -->
          <cx-padding
            class="mt16"
            v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '4') && layoutLevel !== 2 && !isAccordionLayoutRow"
            :paddingTypeFlag.sync="colMarginTypeFlag"
            :padding.sync="colMargin"
            :paddingTop.sync="colMarginTop"
            :paddingRight.sync="colMarginRight"
            :paddingBottom.sync="colMarginBottom"
            :paddingLeft.sync="colMarginLeft"
            paddingName="外边距"
            :sliderMax="500"
          />
        </el-collapse-item>
        </template>
        <!-- end 手风琴布局下只有默认状态下展示 -->

        <!-- start 手风琴布局下展开状态下展示 -->
        <template v-if="isAccordionLayoutCol && status === '1'">
          <el-collapse-item title="背景" name="4">
            <cx-background infoTips="支持上传图片" :background.sync="activeBackground" imgType="10" />
          </el-collapse-item>
          <el-collapse-item title="边框" name="5">
            <div>
              <div class="content-item verticallyCenter mb8">
                <el-checkbox v-model="activeShowBorder">显示边框</el-checkbox>
              </div>
              <cx-border
                v-if="activeShowBorder"
                :borderWidth.sync="activeBorderWidth"
                :borderStyle.sync="activeBorderStyle"
                :borderColor.sync="activeBorderColor"
                :borderIsThemeColor.sync="activeBorderIsThemeColor"
              />
            </div>
            <div class="content-item mt12">
              <border-radius
                :borderTypeFlag.sync="activeBorderTypeFlag"
                :borderRadius.sync="activeBorderRadius"
                :borderTopLeftRadius.sync="activeBorderTopLeftRadius"
                :borderTopRightRadius.sync="activeBorderTopRightRadius"
                :borderBottomRightRadius.sync="activeBorderBottomRightRadius"
                :borderBottomLeftRadius.sync="activeBorderBottomLeftRadius"
              />
            </div>
          </el-collapse-item>
          <el-collapse-item v-if="isLastLevel" title="边距" name="6">
            <cx-padding
              :paddingTypeFlag.sync="activePaddingTypeFlag"
              :padding.sync="activePadding"
              :paddingTop.sync="activePaddingTop"
              :paddingRight.sync="activePaddingRight"
              :paddingBottom.sync="activePaddingBottom"
              :paddingLeft.sync="activePaddingLeft"
              :sliderMax="500"
            />
          </el-collapse-item>
        </template>
        <!-- end 手风琴布局下展开状态下展示 -->
        <el-collapse-item @mousedown.native="collapseMouseDown($event, '7')" title="更多" name="7">
          <div class="content-item">
            <slider-and-input :value.sync="opacity" title="透明度" :sliderMax="100" suffix="%" />
          </div>
          <div class="content-item mt12">
            <div class="checkbox_colorPicker_container">
              <span>阴影</span>
              <span class="icon-portal-plus theme-color right-icon" @click="addBoxshadow"></span>
            </div>
            <box-shadow
              :boxShadowH.sync="boxShadowH"
              :boxShadowV.sync="boxShadowV"
              :boxShadowBlur.sync="boxShadowBlur"
              :boxShadowSpread.sync="boxShadowSpread"
              :boxShadowColor.sync="boxShadowColor"
            ></box-shadow>
          </div>
          <div class="content-item mt12">
            <public-style :options="layoutOptions" :ids="ids"></public-style>
          </div>
          <div class="content-item mt12" style="height: 20px; line-height: 20px" v-if="isTabsPageLayout && layoutLevel==0">
            <el-checkbox
              v-model="renderCurrentTabData"
              >切换标签时加载内容</el-checkbox
            >
            <i class="tips-btn icon-portal-info2" @click="explainDialog1 = true"></i>
          </div>
          <div class="content-item mt12" v-if="isTabsPageLayout && layoutLevel==0" style="height: 20px; line-height: 20px">
            <el-checkbox
              v-model="adaptContentHeight"
            >高度自适应</el-checkbox
            >
<!--            <i class="tips-btn icon-portal-info2" @click="explainDialog1 = true"></i>-->
          </div>
          <div class="content-item verticallyBetweenCenter mt12" v-if="isLastLevel">
            <span class="verticallyCenter">布局模式<i class="tips-btn icon-portal-info2" @click="explainDialog = true"></i></span>
            <el-select v-model="autoLayoutType" style="width: 120px;">
              <el-option v-for="(item, index) in layoutTypeList" :key="index" :label="item.label" :value="item.value">
                <span style="font-size: 13px">{{ item.label }}</span>
              </el-option>
            </el-select>
          </div>
          <div class="content-item verticallyCenter mt12" v-if="isLastLevel">
            <span class="mr16">溢出</span>
            <text-setting-overflow :overFlowType.sync="overFlowType" style="flex: 1"></text-setting-overflow>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
    <el-dialog title="说明" :append-to-body="true" :visible.sync="explainDialog" custom-class="explainDialog">
      <p class="fs14 tips">
        <span>开启条件</span>
      </p>
      <ul>
        <li>行/列组件自动开启</li>
        <li>通栏下的第一个布局也可以开启自动布局，但是排列属性必须是1行1列，并且没有更深层级的行列划分</li>
      </ul>
      <p class="fs14 tips">
        <span>功能说明</span>
      </p>
      <p>
        通常情况下，一个网页的元素是遵从一定的顺序进行排列，例如2张图片横向排列，第3张以及后续图片都希望自动往左侧填充，超过宽度则自动换行，不仅可以减少整理页面的时间还可以实现更灵活的自适应效果。可以理解「自动布局」是为了简化原生页面使用Flex属性，并且达到类似的效果，你可以做到：
      </p>
      <ul>
        <li>让按钮或卡片随文本增减而自动调整尺寸</li>
        <li>将列表快速重新排序</li>
        <li>实现更多更复杂元素的全自动排布</li>
      </ul>
    </el-dialog>
    <el-dialog title="说明" :append-to-body="true" :visible.sync="explainDialog1" custom-class="explainDialog">
      <p class="fs14 tips">
        开启后，除了当前选中的标签下的内容会加载和显示，其他标签下的内容仅在切换选中时才加载和显示。这个开关可以优化一定的页面性能，但每次切换时会有一定加载时间。
      </p>
    </el-dialog>
  </div>
</template>

<script>
import { primaryBigScreenPageLayoutGenerator as primarybigScreenPageLayoutGenerator } from "store/modules/bigScreen/state"
import { primaryStagePageLayoutGenerator as primarystagePageLayoutGenerator } from "store/modules/stage/state"
import { primaryappStagePageLayoutGenerator as primaryappStagePageLayoutGenerator } from "store/modules/appStage/state"
import autoLayoutSetting from "toolbarComponents/colsComponent/setting/autoLayoutSetting.vue"
import rowColLayoutSetting from "../../autoLayout/toolbars/setting/rowColLayoutSetting.vue"
import TextSettingOverflow from "modules/components/textSettingOverflow"
import { deepCloneAndFreeze } from "utils/revork"
const mockData = {
  primarybigScreenPageLayoutGenerator,
  primarystagePageLayoutGenerator,
  primaryappStagePageLayoutGenerator
}
import { withMethodsHistoryCombine } from "utils/revork"
import { isExist } from "../../../utils"
import $ from "jquery"
import controlWidthAndSizeAndZindex from "publicSetting/controlWidthAndSizeAndZindex.vue"
import publicStyle from "publicSetting/publicStyle.vue"

export default withMethodsHistoryCombine({
  name: "cell-layout-options-setting",
  props: {
    mouseType: {
      default: "default",
      type: String
    },
    options: Object
  },
  data() {
    return {
      activeNames: ["1", "2", "3", "4", "5", "6"],
      collapseActiveNames: ["1", "2", "3", "4", "5", "6"],
      hoverOpt: [],
      this1: this,
      activeType: 1,
      sliderMax: 360,
      paddingMax: 200,
      rowLen: 1,
      colLen: 1,
      noReset: false,
      idChange: false,
      before: null,
      disabledAuto: true,
      oldBackground: undefined,
      heightTypes: [
        {
          label: "固定高度",
          value: "px"
        },
        {
          label: "适应内容",
          value: "自动", // 该名称是为了直接用之前的逻辑不能修改
          icon: "icon-portal-hug-height"
        }
      ],
      sizeLists: [
        {
          label: "最大高度",
          value: "showMaxHeight",
          icon: "icon-portal-max-height",
          show: true
        },
        {
          label: "最小高度",
          value: "showMinHeight",
          icon: "icon-portal-min-height",
          show: true
        }
      ],
      explainDialog: false,
      explainDialog1: false,
      statusOptions: [
        {
          value: "0",
          title: "默认"
        },
        {
          value: "1",
          title: "展开"
        }
      ],
      alignmentTypeOptions: [
        {
          value: "top",
          label: "顶对齐",
          iconClass: "icon-portal-align-top"
        },
        {
          value: "center",
          label: "居中对齐",
          iconClass: "icon-portal-align-middle"
        },
        {
          value: "bottom",
          label: "底对齐",
          iconClass: "icon-portal-align-bottom"
        }
      ],
      defaultWidthMax: 99,
      activeWidthMax: 99,
      parentColLen: 1,
      accordionMaxHeight: 400,
      explainTitle: "",
      layoutTypeList: [
        {
          label: "自由拖拽",
          value: "free"
        },{
          label: "纵向排列",
          value: "vertical"
        },{
          label: "横向排列",
          value: "horizon"
        },
      ],
      heightFullTypes: [
        {
          label: "固定高度",
          value: "px"
        },
        {
          label: "充满布局",
          value: "%",
          icon: "icon-portal-fill-height"
        }
      ],
    }
  },
  watch: {
    ids: {
      handler(_, oldVal) {
        // 行数需要回显，列数不需要回显
        console.log("rowLen", this.options.layout.rows)
        let rowLen = this.options.layout.rows?.length > 0 ? this.options.layout.rows.length : 1
        if (rowLen !== this.rowLen) {
          this.noReset = true
          this.rowLen = rowLen
        }
        if (this.colLen !== 1) {
          this.colLen = 1
          this.noReset = true
        }
        if (oldVal !== undefined) {
          this.idChange = true
        }
      },
      deep: true
    },
    rowLen(newVal, oldRowLen) {
      if (this.noReset) {
        this.noReset = false
        return
      }
      this.before = this.getQuickShot()
      let pageLayoutId = this.ids.pageLayoutId
      let layoutIds = pageLayoutId.toString().split("_")
      let curIndex = parseInt(layoutIds[layoutIds.length - 1])
      let layout = new mockData["primary" + this.request_prefix + "PageLayoutGenerator"](1)
      layout = JSON.parse(JSON.stringify(layout.layout.rows[0]))
      //需要先判断当前是属于row 还是 col
      let curCellIsRow = this.parentLayout.layout.rows.length > 0 ? true : false
      // 当前为列， row.length === 1
      let curParentLayout = curCellIsRow ? this.parentLayout : this.parentLayout.layout.cols[curIndex]

      let length = newVal - oldRowLen

      let box =
        this.isLastLevel || this.options.layout.rows.length === 0
          ? curParentLayout.layout.rows
          : this.options.layout.rows
      // 重新计算布局高度时，需要将隐藏的布局排除
      const showRows = curParentLayout.layout.rows.filter(
        row => row.options.isShow !== false && row.options.height !== 0
      )
      let newRowLen = curCellIsRow ? showRows.length + length : newVal
      let height = curParentLayout.options.height / newRowLen
      if (newVal > oldRowLen) {
        if (!curCellIsRow && box.length === 0) {
          // 列变行
          let newRow = JSON.parse(JSON.stringify(this.options))
          newRow.options.width = "100%"
          box.push(newRow)
          this.options.rectIds = []
        }
        // 增加行row
        let newId = 1
        box.forEach(item => {
          newId = item.id && item.id >= newId ? item.id + 1 : newId
        })
        for (let i = 0; i < newVal - oldRowLen; i++) {
          let newLayout = JSON.parse(JSON.stringify(layout))
          newLayout.id = newId
          newId++
          box.push(newLayout)
        }
      } else if (newVal < oldRowLen) {
        // 减少行row
        for (let i = 0; i < oldRowLen - newVal; i++) {
          box.pop()
        }
      }
      box.forEach(item => {
        // 高度计算应该改成百分比 todo
        if (item.options.isShow !== false && item.options.height !== 0) {
          // let changeProportion = height / item.options.height
          item.options.height = 100 / box.length + "%"
          // this.setChildrenH(item, changeProportion)
        } else {
          item.options.height = 0
          // this.setChildrenH(item, 0)
        }
      })
      this.$nextTick(() => {
        if (newVal > oldRowLen) {
          this.restLeftTop(box[0], "row")
        }
        this.addHistory()
      })
      this.updateStatus()
    },
    colLen(newVal, oldRowLen) {
      if (this.noReset) {
        this.noReset = false
        return
      }
      let pageLayoutId = this.ids.pageLayoutId
      if (this.isAccordionLayoutRow) pageLayoutId= "0_0"
      if (!isExist(pageLayoutId)) return
      let layoutIds = pageLayoutId.toString().split("_")
      let curIndex = parseInt(layoutIds[layoutIds.length - 1])
      //需要先判断当前是属于row 还是 col
      let curCellIsRow = this.parentLayout.layout.rows.length > 0 ? true : false
      // 当前为列， row.length === 1
      let curType = curCellIsRow ? "row" : "col"
      // let curType =  "col"
      if (newVal > oldRowLen) {
        this.addCol(this.options, curIndex, curType, this.parentLayout.layout, newVal)
      } else if (newVal < oldRowLen) {
        // 减少行col
        for (let i = 0; i < oldRowLen - newVal; i++) {
          this.delCol(this.options, this.ids.pageLayoutId, curIndex)
        }
      }
    },
    isAccordionLayoutRow: {
      deep: true,
      immediate: true,
      handler(n, o) {
        if (n) {
          // 手风琴布局需要回显列数
          let colLen = this.options.layout.cols?.length > 0 ? this.options.layout.cols?.length : 1
          if (this.colLen !== colLen) {
            this.colLen = colLen
          }
        }
      }
    }
  },
  components: { autoLayoutSetting, rowColLayoutSetting, TextSettingOverflow, controlWidthAndSizeAndZindex, publicStyle },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    isAdmin() {
      return this.$store.state.states.managerType === 1 ? true : false
    },
    isCanAddRow() {
      return (!this.isTabsPageLayout || this.layoutLevel > 4) && !this.showRowColLayout
    },
    isCanAddCol() {
      return (
        !this.isTabsPageLayout ||
        (this.isTabsPageLayout && !this.isVerticalTabsPageLayout && this.layoutLevel > 3) ||
        (this.isVerticalTabsPageLayout && this.layoutLevel > 5)
      )
    },
    isLastLevel() {
      if (!this.options.layout) {
        return true
      }
      if (this.options.layout?.rows?.length > 0 || this.options.layout.cols?.length > 0) {
        return false
      }
      return true
    },
    activeRect() {
      let ids = this.$store.state.states.activeID
      if (ids !== null) {
        this.container_id = ids.container_id
        this.rect_id = ids.rect_id
        return this.$store.state.states.activeID
      } else return null
    },
    layoutLevel() {
      let pageLayoutId = this.ids.pageLayoutId
      if (!this.ids.hasOwnProperty("pageLayoutId") || typeof pageLayoutId === "undefined" || pageLayoutId === null) {
        return 0
      }

      let layoutIds = pageLayoutId.toString().split("_")
      return layoutIds.length
    },
    layoutOptions() {
      console.log("layoutOptions", this.options)
      return this.options.options
    },
    pLeft: {
      get() {
        return this.layoutOptions.pLeft
      },
      set(newVal) {
        this.handleCellSet(newVal, "pLeft")
      }
    },
    pTop: {
      get() {
        return this.layoutOptions.pTop
      },
      set(newVal) {
        this.handleCellSet(newVal, "pTop")
      }
    },
    pRight: {
      get() {
        return this.layoutOptions.pRight
      },
      set(newVal) {
        this.handleCellSet(newVal, "pRight")
      }
    },
    pBottom: {
      get() {
        return this.layoutOptions.pBottom
      },
      set(newVal) {
        this.handleCellSet(newVal, "pBottom")
      }
    },
    translate: {
      get() {
        return this.layoutOptions.translate
      },
      set(newVal) {
        this.handleCellSet(newVal, "translate")
      }
    },
    heightProportion() {
      //当前单元格高度在父元素中所占比例
      return this.height / this.parentLayout.options.height
    },
    showWidthVal: {
      get() {
        return Math.floor(this.width)
      },
      set(newVal) {
        this.width = newVal
      }
    },
    showHeightVal: {
      get() {
        if (this.heightType === "%" && this.isAccordionLayoutCol) return "充满"
        else if (this.heightType === "自动") return "适应"
        else return Math.floor(this.height)
      },
      set(newVal) {
        if (this.heightType === "%" && this.isAccordionLayoutCol) return "充满"
        else if (this.heightType === "自动") this.height = "auto"
        else this.height = newVal
      }
    },
    width: {
      get() {
        return parseFloat(this.layoutOptions.width)
      },
      set(newVal) {
        this.handleCellSet(newVal + "%", "width")
      }
    },
    isFullHeight: {
      get() {
        return this.layoutOptions.isFullHeight
      },
      set(newVal) {
        this.handleCellSet(newVal, "isFullHeight")
      }
    },
    height: {
      get() {
        return this.layoutOptions.height
      },
      set(newVal) {
        if(this.topAdaptContentHeight){
          // 开启高度自适应的情况
          this.layoutOptions.height = newVal
          return
        }
        let oldVal = this.layoutOptions.height
        // 只修改该列，不改变其他的高度
        if (this.isAccordionLayoutCol || this.isAccordionLayoutRow) {
          this.$changeOptionsEV(newVal, "height", false)
          return
        }
        // 新规则，该通栏只有行的时候，只改变当前布局的高度
        if (this.isOnlyHaveRow) {
          this.layoutOptions.height = newVal
          this.reSetParentH(this.ids.pageLayoutId)
        } else {
          // 修改整个通栏里面元素的高度
          let pageLayoutIds = this.ids.pageLayoutId.toString().split("_")
          // this.reSetLayoutH(pageLayoutIds, newVal)
          this.reSetLayoutH1(pageLayoutIds, newVal)
          //修改该布局下的布局的高度
          let editProp = newVal / oldVal
          this.options.layout?.cols?.forEach((item, index) => {
            item.options.height = newVal
            this.setChildLayoutH(editProp, item)
          })
          this.options.layout?.rows?.forEach((item, index) => {
            item.options.height = item.options.height * editProp
            this.setChildLayoutH(editProp, item)
          })
        }
      }
    },
    heightType: {
      get() {
        return this.layoutOptions.heightType || "px"
      },
      set(newVal) {
        this.handleCellSet(newVal, "heightType")
      }
    },
    heightIcon() {
      return this.heightTypes?.find(item => item.value === this.heightType)?.icon
    },
    isOnlyHaveRow() {
      let newPageLayoutId = this.ids.pageLayoutId?.toString().split("_")[0]
      let pageLayout = this.getAttrById.call(
        this,
        this.$store.state[this.request_prefix],
        { container_id: this.ids.container_id, rect_id: this.ids.rect_id, pageLayoutId: newPageLayoutId },
        "pageLayout"
      )
      let colLen = 0
      colLen = this.judgePageLayoutIsOnlyRow(pageLayout, colLen)
      return colLen > 0 ? false : true
    },
    positionType: {
      get() {
        let positionType = this.layoutOptions.positionType
        if (positionType) {
          return positionType
        }
        positionType = this.isFixed ? "fixed" : "relative"
        this.handleCellSet(positionType, "positionType", true)
        return positionType
      },
      set(newVal) {
        this.handleCellSet(newVal, "positionType")
        let pageLayoutIds = this.ids.pageLayoutId.toString().split("_")
        this.reSetLayoutH(pageLayoutIds)
        // 布局绝对定位后；宽度自动改成50%
        if (newVal === "absolute") {
          this.showWidthVal = 50
        }
      }
    },
    isFullPage: {
      get() {
        return this.layoutOptions.isFullPage
      },
      set(newVal) {
        this.handleCellSet(parseInt(newVal), "isFullPage")
      }
    },
    parentLayout: {
      get() {
        let newPageLayoutId
        let pageLayoutId = this.ids.pageLayoutId
        if (this.isAccordionLayoutRow) pageLayoutId = "0_0"
        let ids = pageLayoutId?.toString().split("_")
        ids.splice(ids.length - 1, 1)
        newPageLayoutId = ids.join("_")
        return this.getAttrById.call(
          this,
          this.$store.state[this.request_prefix],
          { container_id: this.ids.container_id, rect_id: this.ids.rect_id, pageLayoutId: newPageLayoutId },
          "pageLayoutComponent"
        )
      },
      set(newVal) {
        let newPageLayoutId
        let ids = this.ids.pageLayoutId.toString().split("_")
        ids.splice(ids.length - 1, 1)
        newPageLayoutId = ids.join("_")
        this.$store.dispatch(this.request_prefix + "/changePageLayoutRow", {
          pageLayoutId: newPageLayoutId,
          pageLayout: newVal
        })
      }
    },
    opacity: {
      get() {
        return this.layoutOptions.hasOwnProperty("opacity") ? this.layoutOptions.opacity : 100
      },
      set(newVal) {
        this.handleCellSet(parseInt(newVal), "opacity")
      }
    },
    background: {
      get() {
        let background = this.layoutOptions.bg
        if (background && Array.isArray(background) && background.length > 0) {
          return background
        }
        let newBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: false,
            color: this.layoutOptions.bgColor || "rgba(255,255,255,0)"
          }
        ]
        this.handleCellSet(newBackground, "bg", true)
        return newBackground
      },
      set(val) {
        this.handleCellSet(val, "bg")
      }
    },
    paddingTypeFlag: {
      get() {
        return this.layoutOptions.paddingTypeFlag
      },
      set(newVal) {
        if (newVal === 1) {
          this.handleCellSet([this.paddingTop, this.paddingTop, this.paddingTop, this.paddingTop], "padding")
        }
        this.handleCellSet(newVal, "paddingTypeFlag")
      }
    },
    padding: {
      get() {
        return this.layoutOptions.padding[0]
      },
      set(newVal) {
        this.handleCellSet([newVal, newVal, newVal, newVal], "padding")
      }
    },
    paddingTop: {
      get() {
        return this.layoutOptions.padding[0]
      },
      set(newVal) {
        this.handleCellSet(newVal, "padding.0")
      }
    },
    paddingRight: {
      get() {
        return this.layoutOptions.padding[1]
      },
      set(newVal) {
        this.handleCellSet(newVal, "padding.1")
      }
    },
    paddingBottom: {
      get() {
        return this.layoutOptions.padding[2]
      },
      set(newVal) {
        this.handleCellSet(newVal, "padding.2")
      }
    },
    paddingLeft: {
      get() {
        return this.layoutOptions.padding[3]
      },
      set(newVal) {
        this.handleCellSet(newVal, "padding.3")
      }
    },
    colMarginTypeFlag: {
      get() {
        return this.layoutOptions.colMarginTypeFlag || 1
      },
      set(newVal) {
        if (newVal === 1) {
          this.handleCellSet([this.colMarginTop, this.colMarginTop, this.colMarginTop, this.colMarginTop], "colMargin")
        }
        this.handleCellSet(newVal, "colMarginTypeFlag")
      }
    },
    colMargin: {
      get() {
        if (!this.layoutOptions.colMargin) {
          this.handleCellSet([0, 0, 0, 0], "colMargin", true)
        }
        return this.layoutOptions.colMargin ? this.layoutOptions.colMargin[0] : 0
      },
      set(newVal) {
        this.handleCellSet([newVal, newVal, newVal, newVal], "colMargin")
      }
    },
    colMarginTop: {
      get() {
        return this.layoutOptions.colMargin ? this.layoutOptions.colMargin[0] : 0
      },
      set(newVal) {
        this.handleCellSet(newVal, "colMargin.0")
      }
    },
    colMarginRight: {
      get() {
        return this.layoutOptions.colMargin ? this.layoutOptions.colMargin[1] : 0
      },
      set(newVal) {
        this.handleCellSet(newVal, "colMargin.1")
      }
    },
    colMarginBottom: {
      get() {
        return this.layoutOptions.colMargin ? this.layoutOptions.colMargin[2] : 0
      },
      set(newVal) {
        this.handleCellSet(newVal, "colMargin.2")
      }
    },
    colMarginLeft: {
      get() {
        return this.layoutOptions.colMargin ? this.layoutOptions.colMargin[3] : 0
      },
      set(newVal) {
        this.handleCellSet(newVal, "colMargin.3")
      }
    },
    borderStyle: {
      get() {
        return this.layoutOptions.borderStyle
      },
      set(newVal) {
        this.handleCellSet(newVal, "borderStyle")
      }
    },
    borderColor: {
      get() {
        return this.layoutOptions.borderColor
      },
      set(newVal) {
        this.handleCellSet(newVal, "borderColor")
      }
    },
    showBorder: {
      get() {
        let showBorder = false
        if (this.layoutOptions.showBorder === undefined) {
          if (this.layoutOptions.borderWidth) {
            showBorder = true
          } else {
            showBorder = false
          }
        } else {
          showBorder = this.layoutOptions.showBorder
        }
        return showBorder
      },
      set(newVal) {
        if(newVal && !this.borderWidth) {
          this.$changeOptionsEV([1, newVal], ["borderWidth", "showBorder"], false)
        } else {
          this.$changeOptionsEV(newVal, "showBorder", false)
        }
      }
    },
    borderWidth: {
      get() {
        return this.layoutOptions.borderWidth
      },
      set(newVal) {
        this.handleCellSet(newVal, "borderWidth")
      }
    },
    borderIsThemeColor: {
      get() {
        return this.layoutOptions.borderIsThemeColor
      },
      set(newVal) {
        this.handleCellSet(newVal, "borderIsThemeColor")
      }
    },
    borderTopLeftRadius: {
      get() {
        return this.layoutOptions.borderRadius[0]
      },
      set(newVal) {
        this.handleCellSet(newVal, "borderRadius.0")
      }
    },
    borderTopRightRadius: {
      get() {
        return this.layoutOptions.borderRadius[1]
      },
      set(newVal) {
        this.handleCellSet(newVal, "borderRadius.1")
      }
    },
    borderBottomRightRadius: {
      get() {
        return this.layoutOptions.borderRadius[2]
      },
      set(newVal) {
        this.handleCellSet(newVal, "borderRadius.2")
      }
    },
    borderBottomLeftRadius: {
      get() {
        return this.layoutOptions.borderRadius[3]
      },
      set(newVal) {
        this.handleCellSet(newVal, "borderRadius.3")
      }
    },
    borderRadius: {
      get() {
        return this.layoutOptions.borderRadius[0]
      },
      set(newVal) {
        this.handleCellSet([newVal, newVal, newVal, newVal], "borderRadius")
      }
    },
    borderTypeFlag: {
      get() {
        let defaultType = 1
        if (!this.options.hasOwnProperty("borderTypeFlag")) {
          if (((this.borderRadius[0] === this.borderRadius[1]) === this.borderRadius[2]) === this.borderRadius[3]) {
            defaultType = 2
          }
        }
        // return this.checkAndSetPrimaryVal(this.options, "borderTypeFlag", "borderTypeFlag", defaultType)
        // 上面方法貌似是执行需要一定的时间，造成最开始还未写入值，进行点击 会出现问题
        return this.layoutOptions.borderTypeFlag || defaultType
      },
      set(newVal) {
        this.handleCellSet(newVal, "borderTypeFlag")
      }
    },
    boxShadowColor: {
      get() {
        return this.checkAndSetPrimaryVal(this.layoutOptions, "boxShadowColor", "boxShadowColor", [
          "rgba(255,255,255,1)"
        ])
      },
      set(newVal) {
        this.handleCellSet(newVal, "boxShadowColor")
      }
    },
    boxShadowH: {
      get() {
        return this.checkAndSetPrimaryVal(this.layoutOptions, "boxShadowH", "boxShadowH", [0])
      },
      set(newVal) {
        this.handleCellSet(newVal, "boxShadowH")
      }
    },
    boxShadowV: {
      get() {
        return this.checkAndSetPrimaryVal(this.layoutOptions, "boxShadowV", "boxShadowV", [0])
      },
      set(newVal) {
        this.handleCellSet(newVal, "boxShadowV")
      }
    },
    boxShadowBlur: {
      get() {
        return this.checkAndSetPrimaryVal(this.layoutOptions, "boxShadowBlur", "boxShadowBlur", [0])
      },
      set(newVal) {
        this.handleCellSet(newVal, "boxShadowBlur")
      }
    },
    boxShadowSpread: {
      get() {
        return this.checkAndSetPrimaryVal(this.layoutOptions, "boxShadowSpread", "boxShadowSpread", [0])
      },
      set(newVal) {
        this.handleCellSet(newVal, "boxShadowSpread")
      }
    },
    // 判断是否是带横向标签的通栏
    topPageLayout(){
      let pageLayout = this.getAttrById.call(this, this.$store.state[this.request_prefix], {
        container_id: this.ids.container_id,
        rect_id: this.ids.rect_id
      })
      return pageLayout
    },
    topPageLayoutOptions() {
      return this.topPageLayout?.options?.layout
    },
    isTabsPageLayout() {
      return this.topPageLayout.options.layout.options.hasOwnProperty("isShowTabs")
        ? this.topPageLayout.options.layout.options.isShowTabs
        : false
    },
    topAdaptContentHeight(){
      return this.topPageLayout.options?.layout?.layout?.rows[0]?.options?.adaptContentHeight
    },
    // 判断是否是带竖向标签的通栏
    isVerticalTabsPageLayout() {
      let pageLayout = this.getAttrById.call(this, this.$store.state[this.request_prefix], {
        container_id: this.ids.container_id,
        rect_id: this.ids.rect_id
      })
      return pageLayout.options.layout.options.hasOwnProperty("isShowVerticalTabs")
        ? pageLayout.options.layout.options.isShowVerticalTabs
        : false
    },
    childSizeAuto: {
      get() {
        return this.layoutOptions?.childSizeAuto || false
      },
      set(newVal) {
        this.handleCellSet(newVal, "childSizeAuto")
      }
    },
    showAutoLayout: {
      get() {
        return this.layoutOptions?.showAutoLayout || false
      },
      set(newVal) {
        this.handleCellSet(newVal, "showAutoLayout")
      }
    },
    marginBottom: {
      get() {
        return this.layoutOptions?.marginBottom || 0
      },
      set(newVal) {
        if (!this.layoutOptions.direction) {
          this.handleCellSet("vertical", "direction")
        }
        this.handleCellSet(newVal, "marginBottom")
      }
    },
    showRowColLayout: {
      get() {
        return this.layoutOptions?.hasOwnProperty("showRowColLayout") ? this.layoutOptions.showRowColLayout : false
      },
      set(newVal) {
        // 重置通栏高度
        if (newVal) this.heightTypeHandleCommand("%")
        this.handleCellSet(newVal, "showRowColLayout")
      }
    },
    disabledHeight() {
      if (this.heightType === "自动" || this.heightType === "%") return true
      else return false
    },
    disabledActiveHeight() {
      if (this.activeHeightType === "自动" || this.activeHeightType === "%") return true
      else return false
    },
    maxHeight: {
      get() {
        return this.layoutOptions.maxHeight
      },
      set(newVal) {
        newVal = newVal < 1 ? 1 : newVal
        this.handleCellSet(newVal, "maxHeight")
      }
    },
    minHeight: {
      get() {
        return this.layoutOptions.minHeight
      },
      set(newVal) {
        this.handleCellSet(newVal, "minHeight")
      }
    },
    showMaxHeight: {
      get() {
        return this.layoutOptions.hasOwnProperty("showMaxHeight") ? this.layoutOptions.showMaxHeight : false
      },
      set(newVal) {
        this.handleCellSet(newVal, "showMaxHeight")
      }
    },
    showMinHeight: {
      get() {
        return this.layoutOptions.hasOwnProperty("showMinHeight") ? this.layoutOptions.showMinHeight : false
      },
      set(newVal) {
        this.handleCellSet(newVal, "showMinHeight")
      }
    },
    overFlowType: {
      get() {
        return this.layoutOptions.hasOwnProperty("overFlowType") ? this.layoutOptions.overFlowType : "visible"
      },
      set(newVal) {
        this.handleCellSet(newVal, "overFlowType")
      }
    },
    firstCellAddTabs() {
      return this.parentLayout?.options?.isShowTabs
    },
    // 初始化时是否全部加载出标签布局下的自由布局和iframe 开启后只加载当前tab下的
    renderCurrentTabData: {
      get() {
        let pageLayout = this.getAttrById.call(this, this.$store.state[this.request_prefix], {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id
        })
        return pageLayout?.options?.hasOwnProperty("renderCurrentTabData") ? pageLayout?.options.renderCurrentTabData : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "renderCurrentTabData", false, null, {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id
        })
      }
    },
    // tab下布局高度是否一致
    adaptContentHeight:{
      get(){
        console.log("layoutOptions",this.layoutOptions)
        return this.checkAndSetPrimaryVal(this.layoutOptions, "adaptContentHeight", "adaptContentHeight",false)
      },
      set(newVal){
        // this.handleCellSet(newVal, "adaptContentHeight")
        this.$changeOptionsEV(
          newVal,
          "adaptContentHeight",
          false,
          undefined,
          {
            ...this.ids,
            pageLayoutId:"1_0"
          }
        )
      }
    },
    // 手风琴布局样式设置
    openIndex: {
      get() {
        return this.topPageLayoutOptions?.options?.hasOwnProperty("openIndex") ? this.topPageLayoutOptions?.options?.openIndex : 0
      },
      set(newVal) {
        this.handleSetLayout("openIndex", newVal)
      }
    },
    status: {
      get() {
        let layoutIndex = this.ids.pageLayoutId?.split("_")
        layoutIndex = layoutIndex[layoutIndex.length - 1]
        return this.openIndex == layoutIndex ? "1" : "0"
      },
      set(newVal) {
        let layoutIndex = this.ids.pageLayoutId?.split("_")
        layoutIndex = layoutIndex[layoutIndex.length - 1]  
        newVal === "1" ? this.openIndex = Number(layoutIndex) : this.openIndex < this.parentColLen - 1 ? this.openIndex++ : this.openIndex--
      }
    },
    alignmentType: {
      get() {
        return this.layoutOptions.hasOwnProperty("alignmentType") ? this.layoutOptions.alignmentType : "center"
      },
      set(newVal) {
        this.handleCellSet(newVal, "alignmentType")
      }
    },
    accordionMargin: {
      get() {
        return this.layoutOptions.hasOwnProperty("accordionMargin") ? this.layoutOptions.accordionMargin : 0
      },
      set(newVal) {
        this.handleCellSet(newVal, "accordionMargin")
      }
    },
    isAccordionLayoutCol() {
      return this.layoutOptions?.isAccordionLayoutCol
    },
    isAccordionLayoutRow() {
      return this.layoutOptions?.isAccordionLayoutRow
    },
    defaultWidth: {
      get() {
        return this.topPageLayoutOptions?.options?.defaultWidth
      },
      set(newVal) {
        this.handleSetLayout("defaultWidth", newVal)
        const colLen = this.isAccordionLayoutCol ? this.parentColLen : this.colLen
        const activeWidth = 100 - (newVal * (colLen - 1)).toFixed()
        this.handleSetLayout("activeWidth", activeWidth)
      }
    },
    activeWidth: {
      get() {
        return this.topPageLayoutOptions?.options?.activeWidth
      },
      set(newVal) {
        this.handleSetLayout("activeWidth", newVal)
        const colLen = this.isAccordionLayoutCol ? this.parentColLen : this.colLen
        const defaultWidth = ((100 - newVal) / (colLen - 1)).toFixed()
        this.handleSetLayout("defaultWidth", defaultWidth)
      }
    },
    activeHeightType: {
      get() {
        return this.layoutOptions.activeHeightType || "px"
      },
      set(newVal) {
        this.handleCellSet(newVal, "activeHeightType")
      }
    },
    activeHeight: {
      get() {
        if (this.activeHeightType === "%" && this.isAccordionLayoutCol) return "充满"
        return this.layoutOptions.hasOwnProperty("activeHeight") ? this.layoutOptions.activeHeight : Number(this.height)?.toFixed(0)
      },
      set(newVal) {
        if (this.activeHeightType === "%" && this.isAccordionLayoutCol) return "充满"
        this.before = this.getQuickShot()
        this.$changeOptionsEV(newVal, "activeHeight", false)
        this.$nextTick(() => {
          this.addHistory()
        })
      }
    },
    activeBackground: {
      get() {
        let background = this.layoutOptions.activeBackground
        if (background && Array.isArray(background) && background.length > 0) {
          return background
        }
        let newBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: false,
            color: this.layoutOptions.bgColor || "rgba(255,255,255,0)"
          }
        ]
        this.handleCellSet(newBackground, "activeBackground")
        return newBackground
      },
      set(val) {
        this.handleCellSet(val, "activeBackground")
      }
    },
    activePaddingTypeFlag: {
      get() {
        return this.layoutOptions.hasOwnProperty("activePaddingTypeFlag") ? this.layoutOptions.activePaddingTypeFlag : 0
      },
      set(newVal) {
        if (newVal === 1) {
          this.handleCellSet([[this.activePaddingTop, this.activePaddingTop, this.activePaddingTop, this.activePaddingTop], newVal], ["padding", "activePaddingTypeFlag"])
        } else {
          this.handleCellSet(newVal, "activePaddingTypeFlag")
        }
      }
    },
    activePadding: {
      get() {
        if (this.layoutOptions.hasOwnProperty("activePadding")) return this.layoutOptions.activePadding[0]
        else {
          this.handleCellSet([0, 0, 0, 0], "activePadding")
          return [0, 0, 0, 0]
        }
      },
      set(newVal) {
        this.handleCellSet([newVal, newVal, newVal, newVal], "activePadding")
      }
    },
    activePaddingTop: {
      get() {
        return this.layoutOptions.activePadding[0]
      },
      set(newVal) {
        this.handleCellSet(newVal, "activePadding.0")
      }
    },
    activePaddingRight: {
      get() {
        return this.layoutOptions.activePadding[1]
      },
      set(newVal) {
        this.handleCellSet(newVal, "activePadding.1")
      }
    },
    activePaddingBottom: {
      get() {
        return this.layoutOptions.activePadding[2]
      },
      set(newVal) {
        this.handleCellSet(newVal, "activePadding.2")
      }
    },
    activePaddingLeft: {
      get() {
        return this.layoutOptions.activePadding[3]
      },
      set(newVal) {
        this.handleCellSet(newVal, "activePadding.3")
      }
    },
    activeBorderStyle: {
      get() {
        return this.layoutOptions.activeBorderStyle || "solid"
      },
      set(newVal) {
        this.handleCellSet(newVal, "activeBorderStyle")
      }
    },
    activeBorderColor: {
      get() {
        return this.layoutOptions.activeBorderColor
      },
      set(newVal) {
        this.handleCellSet(newVal, "activeBorderColor")
      }
    },
    activeShowBorder: {
      get() {
        let showBorder = false
        if (this.layoutOptions.activeShowBorder === undefined) {
          if (this.layoutOptions.activeBorderWidth) {
            showBorder = true
          } else {
            showBorder = false
          }
        } else {
          showBorder = this.layoutOptions.activeShowBorder
        }
        return showBorder
      },
      set(newVal) {
        if(newVal && !this.activeBorderWidth) {
          this.handleCellSet([1, newVal], ["activeBorderWidth", "activeShowBorder"])
        } else {
          this.handleCellSet(newVal, "activeShowBorder")
        }
      }
    },
    activeBorderWidth: {
      get() {
        return this.layoutOptions.activeBorderWidth || 0
      },
      set(newVal) {
        this.handleCellSet(newVal, "activeBorderWidth")
      }
    },
    activeBorderIsThemeColor: {
      get() {
        return this.layoutOptions.activeBorderIsThemeColor || false
      },
      set(newVal) {
        this.handleCellSet(newVal, "activeBorderIsThemeColor")
      }
    },
    activeBorderTopLeftRadius: {
      get() {
        return this.layoutOptions.activeBorderRadius[0]
      },
      set(newVal) {
        this.handleCellSet(newVal, "activeBorderRadius.0")
      }
    },
    activeBorderTopRightRadius: {
      get() {
        return this.layoutOptions.activeBorderRadius[1]
      },
      set(newVal) {
        this.handleCellSet(newVal, "activeBorderRadius.1")
      }
    },
    activeBorderBottomRightRadius: {
      get() {
        return this.layoutOptions.activeBorderRadius[2]
      },
      set(newVal) {
        this.handleCellSet(newVal, "activeBorderRadius.2")
      }
    },
    activeBorderBottomLeftRadius: {
      get() {
        return this.layoutOptions.activeBorderRadius[3]
      },
      set(newVal) {
        this.handleCellSet(newVal, "activeBorderRadius.3")
      }
    },
    activeBorderRadius: {
      get() {
        if (this.layoutOptions.hasOwnProperty('activeBorderRadius')) return this.layoutOptions.activeBorderRadius[0]
        else {
          this.handleCellSet([0, 0, 0, 0], "activeBorderRadius")
          return [0, 0, 0, 0]
        }
      },
      set(newVal) {
        this.handleCellSet([newVal, newVal, newVal, newVal], "activeBorderRadius")
      }
    },
    activeBorderTypeFlag: {
      get() {
        let defaultType = 1
        if (!this.options.hasOwnProperty("activeBorderTypeFlag")) {
          if (((this.activeBorderRadius[0] === this.activeBorderRadius[1]) === this.activeBorderRadius[2]) === this.activeBorderRadius[3]) {
            defaultType = 2
          }
        }
        return this.layoutOptions.activeBorderTypeFlag || defaultType
      },
      set(newVal) {
        this.handleCellSet(newVal, "activeBorderTypeFlag")
      }
    },
    grid() {
      let rect = document.getElementById(`rect_id_${this.ids.rect_id}_layout_${this.ids.pageLayoutId}`)
      let grid
      if (!rect) return
      let gridContent = rect.closest(".grid-item-content")
      const pageLayoutId = gridContent?.getAttribute("pagelayoutid")
      let gridId = gridContent?.getAttribute("data-i")
      const pageIndex = pageLayoutId?.split("_")[0]
      let pageLayout = this.$store.state[this.request_prefix].page.pageLayoutList[pageIndex]
      let layout = pageLayout?.layout?.rows[0]
      if (layout.options.waterFlow) {
        grid = layout.options.gridLayout.find(item => item.i === gridId)
      }
      return grid
    },
    autoLayoutType: {
      get() {
        if (this.showRowColLayout) {
          return this.layoutOptions?.rowColDirection || "vertical"
        } else {
          return "free"
        }
      },
      set(newVal) {
        if (newVal === "free") this.showRowColLayout = false
        else {
          this.showRowColLayout = true
          this.handleSet("rowColDirection", newVal)
        }
      }
    },
  },
  mounted() {
    console.log("ids", this.ids)
    if (this.isAccordionLayoutCol) {
      this.parentColLen = this.parentLayout.layout?.cols?.length || 1
      this.defaultWidthMax = (99 / (this.parentColLen - 1)).toFixed(0)
      this.activeWidthMax = 100 - (this.parentColLen - 1)
      this.accordionMaxHeight = this.grid?.h
    }
  },
  methods: {
    updateStatus() {
      this.$nextTick(() => {
        $(`#layout_${this.ids.pageLayoutId}`).siblings(".layout-sets").find(".default-icon").click()
        this.$store.commit("states/changeShowRightToolbarStatus", true)
        let rowLen = this.options.layout.rows?.length > 0 ? this.options.layout.rows.length : 1
        if (rowLen !== this.rowLen) {
          this.noReset = true
          this.rowLen = rowLen
        }
        if (this.isAccordionLayoutRow) {
          // 手风琴布局需要回显列数
          let colLen = this.options.layout.cols?.length > 0 ? this.options.layout.cols?.length : 1
          if (this.colLen !== colLen) {
            this.noReset = true
            this.colLen = colLen
          }
        }
      })
    },
    handleSet(key, val) {
      this.$changeOptionsEV(val, key, false)
    },
    handleCellSet(val, key, avoidRecord) {
      let rectId = this.ids.rect_id
      let pageLayoutId = this.ids.pageLayoutId
      if (isExist(rectId) && !isExist(pageLayoutId)) {
        this.$changeOptionsEV(
          val,
          key,
          false,
          undefined,
          {
            ...this.ids,
            pageLayoutId: "1_0"
          },
          !!avoidRecord
        )
      }
      if (
        rectId === null ||
        typeof rectId === "undefined" ||
        pageLayoutId === null ||
        typeof pageLayoutId === "undefined"
      ) {
        return
      }

      this.$changeOptionsEV(val, key, false, false, false, !!avoidRecord)
    },
    handleSetLayout(key, val) {
      let rectId = this.ids.rect_id
      if (isExist(rectId)) {        
        this.$changeOptionsEV(val, key, false, "", {
          container_id: this.ids.container_id, 
          rect_id: this.ids.rect_id,
          pageLayoutId: "0"
        },
        true)
      }
      if (
        rectId === null ||
        typeof rectId === "undefined" ||
        pageLayoutId === null ||
        typeof pageLayoutId === "undefined"
      ) {
        return
      }
    },
    judgePageLayoutIsOnlyRow(layout, colLen) {
      if (layout.layout.cols?.length > 0) {
        colLen++
        return colLen
      }
      for (let i = 0; i < layout.layout.rows?.length; i++) {
        colLen = this.judgePageLayoutIsOnlyRow(layout.layout.rows[i], colLen)
        if (colLen > 0) {
          break
        }
      }
      return colLen
    },
    getFocus(event) {
      event.currentTarget.select()
    },
    collapseMouseDown($event, val) {
      if ($event.target.classList[0] === "el-collapse-item__header") {
        const _index = this.collapseActiveNames.findIndex(it => it === val)
        _index === -1 ? this.collapseActiveNames.push(val) : ""
      }
    },
    setChildrenH(layout, changeProportion) {
      layout.layout.cols.forEach(item => {
        item.options.height = layout.options.height
        this.setChildrenH(item, changeProportion)
      })
      layout.layout.rows.forEach(item => {
        item.options.height = item.options.height * changeProportion
        this.setChildrenH(item, changeProportion)
      })
    },
    // 改变padding之后，整体的宽度修改
    // setChildrenWidth(layout,changeProportion){
    //   layout.layout.cols.forEach(item=>{
    //     item.options.width = layout.options.width * changeProportion
    //     this.setChildrenW(item,changeProportion)
    //   })
    //   layout.layout.rows.forEach(item=>{
    //     item.options.width = item.options.width * changeProportion
    //     this.setChildrenW(item,changeProportion)
    //   })
    // },
    // // 改变padding之后，整体的宽度修改
    // setChildrenHeight(layout,changeProportion){
    //   layout.layout.cols.forEach(item=>{
    //     item.options.height = layout.options.height * changeProportion
    //     this.setChildrenW(item,changeProportion)
    //   })
    //   layout.layout.rows.forEach(item=>{
    //     item.options.height = item.options.height * changeProportion
    //     this.setChildrenW(item,changeProportion)
    //   })
    // },
    // // 改变内边距之后重新计算子布局的尺寸
    // setChildrenSize(layout,paddingName,padding){
    //   let isChangeWidth,isChangeHeight
    //   if(paddingName === 'paddingLeft' || paddingName === 'paddingRight' ){
    //     isChangeWidth = true
    //   }else if(paddingName === 'paddingTop' || paddingName === 'paddingBottom' ){
    //     isChangeHeight = true
    //   } else if(paddingName === 'padding'){
    //     isChangeWidth = true
    //     isChangeHeight = true
    //   }
    //   if(!isChangeHeight &&  !isChangeWidth){
    //     return
    //   }
    //   let changeHeightProportion,changeWidthProportion
    //   let childLayout = layout.layout.cols?.length>0?layout.layout.cols : layout.layout.rows.length>0?layout.layout.rows:[]
    //   if(childLayout.length === 0){
    //     return
    //   }
    //   if(isChangeHeight){
    //     changeHeightProportion =  (layout.options.height - padding[0] - padding[2])/layout.options.height
    //     layout.options.height = layout.options.height - - padding[0] - padding[2]
    //   }
    //   // if(isChangeWidth){
    //   //
    //   // }
    //   childLayout.forEach(item=>{
    //     if(isChangeHeight){
    //       item.options.height = layout.options.height * changeHeightProportion
    //       this.setChildrenHeight(item,changeHeightProportion)
    //     }
    //     // if(isChangeWidth){
    //     //   item.options.width = layout.options.width * changeWidthProportion
    //     //   this.setChildrenWidth(item,changeWidthProportion)
    //     // }
    //   })
    // },
    changeRowLen(flag) {
      if (this.rowLen === 1 && flag === 0) {
        return
      }
      if (this.rowLen === 10 && flag === 1) {
        return
      }
      this.isFullHeight = false // 添加了同级行，因为要平分高度，所以关掉高度占满屏幕高度的复选框
      this.rowLen = flag === 0 ? this.rowLen - 1 : this.rowLen + 1
    },
    changeColLen(flag) {
      if (this.colLen === (this.isAccordionLayoutRow ? 2 : 1) && flag === 0) {
        return
      }
      if (this.colLen === 10 && flag === 1) {
        return
      }
      this.colLen = flag === 0 ? this.colLen - 1 : this.colLen + 1
    },
    // 一层一层网上找，设置父级的高度
    reSetParentH(pageLayoutIds) {
      let ids = pageLayoutIds.split("_")
      let parentLayoutH = 0
      let parentLayout = this.getParentLayout(ids)
      ids.splice(ids.length - 1, 1)
      let newPageLayoutId = ids.join("_")
      parentLayout.layout.rows.forEach((item, index) => {
        if (!item.options.positionType || item.options.positionType === "relative") {
          // 如果定位，当前布局尺寸改变 不影响其他布局的尺寸
          parentLayoutH += parseInt(item.options.height)
        }
      })
      this.$changeOptionsEV(parentLayoutH, "height", false, "", {
        pageLayoutId: newPageLayoutId
      })

      if (ids.length > 1) {
        this.reSetParentH(newPageLayoutId)
      }
    },
    // 重新计算整个通栏每层 每个格子的高度
    // 此方法是 不管当前布局是行还是列 只改此布局的尺寸  兄弟行不变 兄弟列一起更改 不在按照以前的那种比例来
    reSetLayoutH1(pageLayoutIds, curLayoutH) {
      let curLevel = pageLayoutIds.length
      let curIndex = parseInt(pageLayoutIds[pageLayoutIds.length - 1])
      let parentIndex = parseInt(pageLayoutIds[pageLayoutIds.length - 2])
      if (curLevel === 1) {
        return
      }
      // 重新获取父级布局
      let parentLayout = this.getParentLayout(pageLayoutIds)
      let curCellIsRow = parentLayout.layout.rows.length > 0 ? true : false
      let curPagelayout = curCellIsRow ? parentLayout.layout.rows[curIndex] : parentLayout.layout.cols[curIndex]
      let parentLayoutH = 0
      curLayoutH = curLayoutH || curPagelayout.options.height
      let editProp = curLayoutH / curPagelayout.options.height
      if (curCellIsRow) {
        parentLayout.layout.rows.forEach((item, index) => {
          if (index === curIndex) {
            item.options.height = curLayoutH
          } else if (!item.options.positionType || item.options.positionType === "relative") {
            // 如果定位，当前布局尺寸改变 不影响其他布局的尺寸
            // item.options.height = item.options.height * editProp
            // this.setChildLayoutH(editProp, item)
          }
          if (!item.options.positionType || item.options.positionType === "relative") {
            parentLayoutH += parseFloat(item.options.height)
          }
        })
      } else {
        parentLayout.layout.cols.forEach((item, index) => {
          item.options.height = curLayoutH
          if (index !== curIndex) {
            this.setChildLayoutH(editProp, item)
          }
        })
        parentLayoutH = curLayoutH
      }

      pageLayoutIds.splice(pageLayoutIds.length - 1, 1)
      if (curLevel === 2) {
        let newPageLayoutIds = pageLayoutIds.join("_")
        this.$store.dispatch(this.request_prefix + "/changePageLayoutRow", {
          pageLayoutId: newPageLayoutIds,
          pageLayout: parentLayout.layout.rows
        })
        this.$store.dispatch(this.request_prefix + "/changePageLayoutRow", {
          pageLayoutId: newPageLayoutIds,
          pageLayout: parentLayout.layout.rows
        })
        this.$changeOptionsEV(parentLayoutH, "height", false, "", {
          ...this.ids,
          pageLayoutId: pageLayoutIds
        })
      }
      return this.reSetLayoutH1(pageLayoutIds, parentLayoutH)
    },
    // 重新计算整个通栏每层 每个格子的高度
    reSetLayoutH(pageLayoutIds, curLayoutH) {
      let curLevel = pageLayoutIds.length
      let curIndex = parseInt(pageLayoutIds[pageLayoutIds.length - 1])
      let parentIndex = parseInt(pageLayoutIds[pageLayoutIds.length - 2])
      if (curLevel === 1) {
        return
      }
      // 重新获取父级布局
      let parentLayout = this.getParentLayout(pageLayoutIds)
      let curCellIsRow = parentLayout.layout.rows.length > 0 ? true : false
      let curPagelayout = curCellIsRow ? parentLayout.layout.rows[curIndex] : parentLayout.layout.cols[curIndex]
      let parentLayoutH = 0
      curLayoutH = curLayoutH || curPagelayout.options.height
      let editProp = curLayoutH / curPagelayout.options.height
      if (curCellIsRow) {
        parentLayout.layout.rows.forEach((item, index) => {
          if (index === curIndex) {
            item.options.height = curLayoutH
          } else if (!item.options.positionType || item.options.positionType === "relative") {
            // 如果定位，当前布局尺寸改变 不影响其他布局的尺寸
            item.options.height = item.options.height * editProp
            this.setChildLayoutH(editProp, item)
          }
          if (!item.options.positionType || item.options.positionType === "relative") {
            parentLayoutH += parseFloat(item.options.height)
          }
        })
      } else {
        parentLayout.layout.cols.forEach((item, index) => {
          item.options.height = curLayoutH
          if (index !== curIndex) {
            this.setChildLayoutH(editProp, item)
          }
        })
        parentLayoutH = curLayoutH
      }

      pageLayoutIds.splice(pageLayoutIds.length - 1, 1)
      if (curLevel === 2) {
        let newPageLayoutIds = pageLayoutIds.join("_")
        this.$store.dispatch(this.request_prefix + "/changePageLayoutRow", {
          pageLayoutId: newPageLayoutIds,
          pageLayout: parentLayout.layout.rows
        })
        this.$store.dispatch(this.request_prefix + "/changePageLayoutRow", {
          pageLayoutId: newPageLayoutIds,
          pageLayout: parentLayout.layout.rows
        })
        this.$changeOptionsEV(parentLayoutH, "height", false, "", {
          pageLayoutId: pageLayoutIds[0]
        })
      }
      return this.reSetLayoutH(pageLayoutIds, parentLayoutH)
    },
    // 获取父级
    getParentLayout(pageLayoutIds) {
      let newPageLayoutId = JSON.parse(JSON.stringify(pageLayoutIds))
      newPageLayoutId.splice(pageLayoutIds.length - 1, 1)
      newPageLayoutId = newPageLayoutId.join("_")
      return this.getAttrById.call(
        this,
        this.$store.state[this.request_prefix],
        { container_id: this.ids.container_id, rect_id: this.ids.rect_id, pageLayoutId: newPageLayoutId },
        "pageLayout"
      )
    },
    // 设置子元素的高度
    setChildLayoutH(editProp, child) {
      if (child.layout.rows.length === 0 && child.layout.cols.length === 0) {
        // 没有子元素啦
        return
      }
      let curCellIsRow = child.layout.rows.length > 0 ? true : false
      let layout = curCellIsRow ? child.layout.rows : child.layout.cols
      layout.forEach(item => {
        console.log(editProp)
        item.options.height = item.options.height * editProp
        this.setChildLayoutH(editProp, item)
      })
    },
    // 添加列
    addCol(cellVal, index, curType, parentCol, newLength) {
      this.before = this.getQuickShot()
      // cellVal 当前单元格  index 当前单元格索引  curType当前单元格类型，行或者列   parentCol 当前单元格父级   isCopy 是新增还是复制
      let layout = new mockData["primary" + this.request_prefix + "PageLayoutGenerator"]()
      let newCol = layout.layout.rows[0]
      let newId = 1
      // curType为当前单元格的类型
      switch (curType) {
        case "col":
          // 新增一个列
          let colWidth1 = 100 / (parentCol.cols.length + 1) + "%"
          let oldCol = cellVal
          oldCol.options.width = parseFloat(oldCol.options.width) / 2 + "%"
          parentCol.cols.forEach(item => {
            newId = item.id && item.id >= newId ? item.id + 1 : newId
          })
          newCol.id = newId
          newCol.rectIds = []
          // newCol.options.width = oldCol.options.width;
          newCol.options.height = oldCol.options.height
          parentCol.cols.splice(index, 0, newCol)
          parentCol.cols.forEach(item => {
            item.options.width = colWidth1
          })
          this.$nextTick(() => {
            this.restLeftTop(oldCol, "col")
          })
          break
        case "row":
          if (newLength === cellVal.layout.cols.length) return
          // 新增列
          if (cellVal.layout.cols.length > 0) {
            let colWidth = 100 / (cellVal.layout.cols.length + 1) + "%"
            let oldCol1 = cellVal.layout.cols[cellVal.layout.cols.length - 1]
            // oldCol1.options.width = parseFloat(oldCol1.options.width) / 2 + "%";
            newCol.rectIds = []
            // newCol.options.width = oldCol1.options.width;
            newCol.options.height = oldCol1.options.height
            cellVal.layout.cols.forEach(item => {
              newId = item.id && item.id >= newId ? item.id + 1 : newId
            })
            newCol.id = newId
            if (this.isAccordionLayoutRow) {
              newCol.options.isAccordionLayoutCol = true
            }
            cellVal.layout.cols.push(newCol)
            cellVal.layout.cols.forEach(item => {
              item.options.width = colWidth
            })
            this.$nextTick(() => {
              this.restLeftTop(oldCol1, "col")
            })
            if (this.isAccordionLayoutRow) {
              //重置手风琴布局的宽度
              this.activeWidth = this.topPageLayoutOptions?.options?.activeWidth
            }
          } else {
            // 当前行划分成列
            let oldCol2 = JSON.parse(JSON.stringify(cellVal))
            oldCol2.options.width = "50%"
            oldCol2.options.height = "100%"
            oldCol2.id = 0
            newCol.rectIds = []
            newCol.options.width = "50%"
            // newCol.options.height = oldCol2.options.height
            newCol.options.height = "100%"
            newCol.id = 1
            cellVal.rectIds = []
            cellVal.layout.cols.splice(0, 0, oldCol2, newCol)
            this.$nextTick(() => {
              this.restLeftTop(oldCol2, "col")
            })
          }
          break
      }
      this.$nextTick(() => {
        this.addHistory()
      })
    },
    // 重置贴边元素的横纵坐标
    restLeftTop(layout, type) {
      if (layout?.rectIds?.length > 0) {
        layout.rectIds?.forEach(item => {
          let elementNode = document.getElementsByClassName(
            "container_id_" + this.ids.container_id + "-rect_id_" + item
          )
          if (!elementNode || elementNode.length === 0) return
          let parentNode = elementNode[0].parentNode
          if (!parentNode) return
          const page = this.$store.state[this.request_prefix].page
          const containerIndex = page.children.findIndex(container => container.container_id === this.ids.container_id)
          if (containerIndex === -1) return
          const rectItem = page.children[containerIndex].children.find(rect => rect.rect_id === item)
          if (rectItem && rectItem.options) {
            if (type === "col" && rectItem.options?.leftType !== "%") {
              // 贴边元素新增列时会显示在布局外面 设置最大左偏移值
              let maxLeft = parentNode?.offsetWidth - elementNode[0].offsetWidth
              if (Number(rectItem.options.left) > Number(maxLeft)) {
                this.$changeOptionsEV(maxLeft, "left", false, null, {
                  container_id: this.ids.container_id,
                  rect_id: item
                })
              }
            }
            if (type === "row" && rectItem.options?.topType !== "%") {
              // 贴边元素新增行时会显示在布局外面 设置最大上偏移值
              let maxTop = parentNode?.offsetHeight - elementNode[0].offsetHeight
              if (Number(rectItem.options.top) > Number(maxTop)) {
                this.$changeOptionsEV(maxTop, "top", false, null, {
                  container_id: this.ids.container_id,
                  rect_id: item
                })
              }
            }
          }
        })
      }
    },
    // 删除行 列
    delCol(cellVal, layoutIndex, index) {
      let parentLayoutVal = this.parentLayout.layout
      let pageLayoutId = layoutIndex
      if (this.isAccordionLayoutRow) pageLayoutId = "0_0"
      let parentIndex = pageLayoutId.split("_")
      parentIndex = pageLayoutId[pageLayoutId.length - 1]
      let isRow = parentLayoutVal.rows.length ? true : false
      let layout = isRow ? parentLayoutVal.rows[parentIndex].layout.cols : parentLayoutVal.cols
      let curCellWidth = parseFloat(cellVal.options.width)
      let curCellHeight = cellVal.options.height
      // 删除单元格内的组件
      // this.delElementHandle(cellVal)
      if (layout.length === 0) {
        // 没有兄弟元素的时候直接删除
        layout.splice(index, 1)
        return
      }
      // 手风琴布局从后面删除
      if (this.isAccordionLayoutRow) {
        layout.length - 1 === this.openIndex ? this.openIndex = 0 : ""
        layout.pop()
      }
      else layout.splice(index, 1)
      // 方案1,有删除之后 宽度平分

      let newWidth = 100 / layout.length + "%"
      layout.forEach(item => {
        item.options.width = newWidth
      })
      if (this.isAccordionLayoutRow) {
        //重置手风琴布局的宽度
        this.activeWidth = this.topPageLayoutOptions?.options?.activeWidth
      }
    },
    addBoxshadow() {
      if (!Array.isArray(this.boxShadowH)) {
        this.boxShadowH = [this.boxShadowH]
        this.boxShadowV = [this.boxShadowV]
        this.boxShadowBlur = [this.boxShadowBlur]
        this.boxShadowSpread = [this.boxShadowSpread]
        this.boxShadowColor = [this.boxShadowColor]
      }
      let boxShadowH = JSON.parse(JSON.stringify(this.boxShadowH))
      let boxShadowV = JSON.parse(JSON.stringify(this.boxShadowV))
      let boxShadowBlur = JSON.parse(JSON.stringify(this.boxShadowBlur))
      let boxShadowSpread = JSON.parse(JSON.stringify(this.boxShadowSpread))
      let boxShadowColor = JSON.parse(JSON.stringify(this.boxShadowColor))
      boxShadowH.push(0)
      boxShadowV.push(4)
      boxShadowBlur.push(4)
      boxShadowSpread.push(0)
      boxShadowColor.push("rgba(0,0,0,0.25)")
      this.boxShadowH = boxShadowH
      this.boxShadowV = boxShadowV
      this.boxShadowBlur = boxShadowBlur
      this.boxShadowSpread = boxShadowSpread
      this.boxShadowColor = boxShadowColor
    },
    /* 判断当前通栏下的元素是否全都是充满且没有填充子元素， 是则不能修改当前布局为自适应 */
    childNoHeight() {
      let rectIds = this.options.rectIds
      if (!rectIds || rectIds?.length === 0) {
        // 没有子元素啦
        return true
      }
      return rectIds.every(item => {
        let rect = this.getAttrById.call(
          this,
          this.$store.state[this.request_prefix],
          {
            container_id: this.ids.container_id,
            rect_id: item
          },
          "rect"
        )
        let noElement = !rect.options.elementOptions || rect.options.elementOptions.length === 0
        return rect.options.heightType === "%" && noElement
      })
    },
    // 当设置高度自适应时，需要重新设置子元素为固定高度
    setChildHeight() {
      let rectIds = this.options.rectIds
      // let allFill = true
      // if (this.layoutOptions.rowColDirection === "horizon") {// 水平需要判断所有高度都是充满
      //   allFill = rectIds.every(item => {
      //     let rect = this.getAttrById.call(
      //       this,
      //       this.$store.state[this.request_prefix],
      //       {
      //         container_id: this.ids.container_id,
      //         rect_id: item
      //       },
      //       "rect"
      //     )
      //     return rect.options.heightType === "%"
      //   })
      // }
      // if (!allFill) return
      rectIds.forEach(item => {
        let ids = {
          container_id: this.ids.container_id,
          rect_id: item
        }
        let rect = this.getAttrById.call(this, this.$store.state[this.request_prefix], ids, "rect")
        let className = `container_id_${this.ids.container_id}-rect_id_${item}`
        let element = document.getElementsByClassName(className)[0]
        let client = element?.getBoundingClientRect()
        let boundHeight = client && client.height
        if (rect.options.heightType === "%") {
          this.$changeOptionsEV(boundHeight, "height", null, false, ids)
          this.$changeOptionsEV("px", "heightType", null, false, ids)
        }
      })
    },
    heightTypeHandleCommand(val) {
      if (this.heightType === val) {
        return
      }
      let rectIds = this.options.rectIds
      if (val === "自动" && (!rectIds || rectIds?.length === 0)) {
        this.$message({
          customClass: "bigScreen_msg_backGroud",
          duration: 3000,
          message: "不能切换为适应，请检查是否有子元素！",
          type: "warning"
        })
        return
      }
      this.heightType = val
      if (val === "自动") {
        this.setChildHeight()
        this.showHeightVal = "适应"
      } else {
        this.showHeightVal = this.showHeightVal || this.layoutOptions?.boundHeight || 200
        this.showMaxHeight = false
        this.showMinHeight = false
        this.sizeLists.forEach(item => {
          if (item.value === "showMaxHeight" || item.value === "showMinHeight") {
            item.show = true
          }
        })
      }
    },
    activeHeightTypeHandleCommand(val) {
      if (this.activeHeightType === val) {
        return
      }
      this.activeHeightType = val
    },
    addHandleCommand(command, type, index) {
      if (!command) return
      this[command] = true
      this.sizeLists.forEach(item => {
        if (item.value === command) {
          item.show = false
        }
      })
    },
    delHandleCommand(val) {
      this[val] = false
      this.sizeLists.forEach(item => {
        if (item.value === val) {
          item.show = true
        }
      })
    },
    // 获取当前快照
    getQuickShot() {
      const { container_id, rect_id } = this.ids
      const page = this.$store.state[this.request_prefix].page
      const rect = page.children[0].children.find(rect => rect.rect_id === rect_id)
      return deepCloneAndFreeze(rect)
    },
    // 记录状态
    addHistory() {
      const newData = this.getQuickShot()
      this.$addHistory({
        type: "update",
        stateType: "updateRect",
        payload: {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id
        },
        before: this.before,
        data: newData
      })
      this.before = null
    }
  }
})
</script>

<style scoped lang="scss">
p {
  margin-bottom: 0;
}
.arrange-sets {
  justify-content: space-between;
}
.row-set {
  flex: 1;
  input {
    background-color: var(--inputBg);
    border-radius: 4px;
    padding: 0 10px;
    box-sizing: border-box;
    margin-right: 16px;
  }
  .btn-wrapper {
    background-color: var(--inputBg);
    border-radius: 4px;
    padding: 6px 0;
    font-size: 0;
    flex: 1;
    .num-btn {
      display: inline-block;
      width: 50%;
      text-align: center;
      line-height: 20px;
      font-size: 13px;
      cursor: pointer;
      &:not(:last-child) {
        border-right: 1px solid var(--sliderBackGround);
      }
      &:not(.disabled):hover {
        color: var(--themeColor);
      }
      &.disabled {
        color: var(--borderColorSeven);
        cursor: not-allowed;
      }
    }
  }
}

.lineHeight32 {
  display: inline-block;
  line-height: 32px;
}
::v-deep input {
  color: var(--textColor);
}
::v-deep.content-group-default .el-input input {
  background: var(--inputBackGround);
  color: var(--textColor);
}
.add-col-wrap {
  font-size: 14px;
  background-color: var(--inputBg);
  border-radius: 4px;
  text-align: center;
  line-height: 32px;
  height: 32px;
  color: var(--subTextColor);
  cursor: pointer;
  span {
    display: inline-block;
    vertical-align: middle;
  }
  .icon {
    font-size: 20px;
    margin-right: 4px;
  }
  &:hover {
    color: var(--themeColor);
  }
}
.tips-btn {
  margin-top: 1px;
}
::v-deep .el-dropdown-link {
  color: var(--subTextColor) !important;
}

::v-deep .input-size .el-input__suffix {
  right: 4px;
}

::v-deep .input-size .el-dropdown-link {
  width: 24px;
  height: 24px;
  line-height: 24px;
  border-radius: 3px;
  margin: 4px 0;
}

::v-deep .input-size .el-dropdown-link:hover {
  background: var(--paddingIconHoverColor);
}

::v-deep .input-size.el-input.is-disabled .el-input__inner {
  background: var(--inputBackGround) !important;
}

.selected-icon {
  position: absolute;
  top: 50%;
  left: 12px;
  font-size: 16px;
  color: var(--themeColor);
  transform: translateY(-50%);
}

.dropdown-size {
  margin-top: -32px;
}

.dropdown-size li {
  position: relative;
  width: 100px;
  padding-left: 36px;
  padding-right: 12px;
}

.el-dropdown-menu__item {
  color: var(--textColor);
  font-size: 13px;
}
.custom-menu {
  .el-dropdown-menu__item {
    line-height: 38px;
    padding: 0 12px;

    .icon {
      display: inline-block;
      vertical-align: top;
      margin-top: 10px;
      font-size: 16px;
      margin-right: 8px;
    }
  }
}
.flexEnd {
  display: flex;
  justify-content: flex-end;
}
::v-deep .explainDialog .el-dialog__body {
  line-height: 1.75;
}
::v-deep .explainDialog .el-dialog__body li:before {
  content: "";
  display: inline-block;
  vertical-align: middle;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: black;
  margin-right: 10px;
}
</style>
